import React, { useMemo } from 'react'
import { ColumnsType } from 'antd/es/table'
import { StyledTypographyText, StyledTypographyTitle } from '../../../styled-components/Typography'
import { Col, Row, Space } from 'antd'
import { StyledCard } from '../../../styled-components/Card'
import { StyledOverviewTableRecommend } from '../../../styled-components/Table'
import { AutoSuggestReportAPI } from '../structure/structureOverviewPreviewReport'
import { FieldType } from '../../questionnaire/FormStructureQuestionnaireType'

const toDataSource = (data: TableDataSource[]) => {
    return data.map(({ questions, ...purpose }, indexPurposes: number) => {
        return {
            id: purpose.id,
            name: purpose.name,
            recommend: questions,
        }
    })
}

export const rewriteRecommendToReport = ({
    dataSource,
    prefixLabel,
    mode = 'recommend',
}: {
    dataSource: TableDataSource[]
    prefixLabel: string
    mode?: ModeTableRecommended
}) => {
    let indexQuestionNumber = 0
    let questionNumber = 0

    let newDataSource = dataSource.map(({ questions, ...item }, indexPurpose) => {
        return {
            ...item,
            name: `${prefixLabel}${indexPurpose + 1} ${item.name}`,
            questions: (() => {
                if (indexPurpose === 0) {
                    return questions.map((question, index) => {
                        questionNumber = questionNumber + 1
                        return { ...question, name: `ข้อการประเมินที่ ${index + 1}. ${question.name}` }
                    })
                } else {
                    return questions.map((question, index) => {
                        indexQuestionNumber = indexQuestionNumber + 1
                        return {
                            ...question,
                            name: `ข้อการประเมินที่ ${questionNumber + indexQuestionNumber}. ${question.name}`,
                        }
                    })
                }
            })(),
        }
    })

    if (mode === 'recommend') {
        return newDataSource
            .map(({ questions, ...item }, indexPurpose) => {
                return {
                    ...item,
                    questions: questions.filter((item) => item.value),
                }
            })
            .filter((item) => item.questions.length)
    }

    return newDataSource
        .map(({ questions, ...item }, indexPurpose) => {
            return {
                ...item,
                questions: questions.filter(({ autoRecommended = [] }) => autoRecommended.length),
            }
        })
        .filter((item) => item.questions.length)
}

export type TableDataSource = {
    id: string | number
    name: string
    scoreFull: number
    scoreUser: number | null
    // gradeUser: string
    scoreAdmin: number | null
    // gradeAdmin: string
    descriptionAdmin: string
    descriptionUser: string
    questions: {
        id: string | number
        name: string
        value: string | null
        autoRecommended?: AutoSuggestReportAPI[]
        fieldType: FieldType
    }[]
    [key: string]: any
}

type RecommendObj = {
    name: string
    value: string | null | undefined
    autoRecommended?: AutoSuggestReportAPI[]
    fieldType: FieldType
}

type TableRows = {
    id: string | number
    name: string
    recommend: RecommendObj[]
}

export type ModeTableRecommended = 'auto-recommend' | 'recommend'

type ReturnTypeUseOverviewTableRecommend = ReturnType<typeof useOverviewTableRecommend>
type UseOverviewTableRecommend = {
    dataSource?: TableDataSource[]
    prefixLabel: string
    titleCell: string
    mode?: ModeTableRecommended
}

const useOverviewTableRecommend = ({
    dataSource = [],
    prefixLabel,
    titleCell,
    mode = 'recommend',
}: UseOverviewTableRecommend) => {
    const columns: ColumnsType<TableRows> = [
        {
            title: titleCell,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
        },
        {
            title: 'คำแนะนำโดยละเอียด',
            dataIndex: 'recommend',
            key: 'recommend',

            align: 'left',
            render: (value: RecommendObj[]) => {
                return (
                    <>
                        {value.map(({ autoRecommended = [], fieldType, ...itm }: RecommendObj, index: number) => {
                            return (
                                <div>
                                    <Space direction='vertical' key={index}>
                                        <StyledTypographyText
                                            css={{
                                                color: 'black',
                                                fontWeight: 600,
                                            }}
                                        >
                                            {`${itm.name}`}
                                        </StyledTypographyText>

                                        {mode === 'recommend' ? (
                                            <div
                                                style={{
                                                    marginLeft: 20,
                                                    marginRight: 20,
                                                }}
                                            >
                                                {`- ${itm.value}` || '-'}
                                            </div>
                                        ) : (
                                            autoRecommended.map((autoRec) => {
                                                return (
                                                    <React.Fragment>
                                                        {fieldType === FieldType.CHECKBOX_GROUP ? (
                                                            <React.Fragment key={autoRec.answerOrder}>
                                                                <div
                                                                    style={{
                                                                        color: 'black',
                                                                        fontWeight: 600,
                                                                        //padding: 20,
                                                                        marginLeft: 20,
                                                                        marginRight: 20,
                                                                    }}
                                                                >
                                                                    {`หัวข้อใหญ่ที่ ${autoRec.subQuestionID}.  ${autoRec.subQuestionName}`}
                                                                </div>
                                                                {autoRec.subAnswer?.map((subAnswer) => {
                                                                    return (
                                                                        <React.Fragment>
                                                                            <div
                                                                                style={{
                                                                                    color: 'black',
                                                                                    fontWeight: 600,
                                                                                    //padding: 20,
                                                                                    marginLeft: 40,
                                                                                    marginRight: 20,
                                                                                }}
                                                                            >
                                                                                {`ตัวเลือกที่ ${subAnswer.answerOrder}.  ${subAnswer.answerName}`}
                                                                            </div>

                                                                            <div
                                                                                style={{
                                                                                    marginRight: 20,
                                                                                    marginLeft: 40,
                                                                                }}
                                                                            >
                                                                                {`- ${subAnswer.answerSuggestion}` ||
                                                                                    '-'}
                                                                            </div>
                                                                        </React.Fragment>
                                                                    )
                                                                })}
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment key={autoRec.answerOrder}>
                                                                <div
                                                                    style={{
                                                                        color: 'black',
                                                                        fontWeight: 600,
                                                                        //padding: 20,
                                                                        marginLeft: 20,
                                                                        marginRight: 20,
                                                                    }}
                                                                >
                                                                    {`ตัวเลือกที่ ${autoRec.answerOrder}.  ${autoRec.answerName}`}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        marginRight: 20,
                                                                        marginLeft: 20,
                                                                    }}
                                                                >
                                                                    {`- ${autoRec.answerSuggestion}` || '-'}
                                                                </div>
                                                            </React.Fragment>
                                                        )}
                                                    </React.Fragment>
                                                )
                                            })
                                        )}
                                    </Space>
                                </div>
                            )
                        })}
                    </>
                )
            },
        },
    ]

    const bindDataSource = useMemo(() => toDataSource(rewriteRecommendToReport({ dataSource, mode, prefixLabel })), [
        dataSource,
        mode,
        prefixLabel,
    ])

    return { columns, dataSource: bindDataSource }
}

type OverviewTableRecommendViewProps = { dataSource?: TableRows[]; title: string } & ReturnTypeUseOverviewTableRecommend
const OverviewTableRecommendView: React.FC<OverviewTableRecommendViewProps> = ({ columns, dataSource = [], title }) => {
    return (
        <StyledCard
            bodyStyle={{ overflow: 'auto' }}
            bordered={false}
            title={
                <StyledTypographyTitle
                    styled={{
                        fontFamily: 'THSarabunNew',
                    }}
                    level={3}
                >
                    {title}
                </StyledTypographyTitle>
            }
        >
            <Row justify='center'>
                <Col span={24}>
                    <StyledOverviewTableRecommend<TableRows>
                        bordered
                        pagination={false}
                        columns={columns}
                        dataSource={dataSource}
                        rowKey='id'
                        locale={{
                            emptyText: <span>ไม่มีข้อมูล</span>,
                        }}
                    />
                </Col>
            </Row>
        </StyledCard>
    )
}

type OverviewTableRecommendProps = { mode?: ModeTableRecommended } & UseOverviewTableRecommend &
    Omit<OverviewTableRecommendViewProps, keyof ReturnTypeUseOverviewTableRecommend>
const OverviewTableRecommend: React.FC<OverviewTableRecommendProps> = ({
    prefixLabel,
    titleCell,
    dataSource,
    mode,
    ...props
}) => {
    const state = useOverviewTableRecommend({ prefixLabel, titleCell, dataSource, mode })
    return <OverviewTableRecommendView {...state} {...props} />
}

export default OverviewTableRecommend
